import { render, staticRenderFns } from "./StoreSnackbar.vue?vue&type=template&id=6ab84aa1&scoped=true&"
import script from "./StoreSnackbar.vue?vue&type=script&lang=js&"
export * from "./StoreSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./StoreSnackbar.vue?vue&type=style&index=0&id=6ab84aa1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab84aa1",
  null
  
)

export default component.exports